import { LaunchMoment, FinalBrand } from "../components/v2/NetworkSections";
import { usePageMeta } from "../lib/usePageMeta";

export default function WaitlistPage() {
  usePageMeta("HUMN is Live — The Wait Is Over", "HUMN, The Ai Social Network, is now live on Google Play.");
  return <main data-testid="launch-page"><LaunchMoment compact /><FinalBrand /></main>;
}